import React, { useEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";



import Slide1 from '../../images/slider/imoje.png';
import Slide2 from '../../images/slider/text-o.png';
import Slide3 from '../../images/slider/bg-img.jpg';
import Slide4 from '../../images/slider/start.svg';
import Slide5 from '../../images/slider/bg-shap.svg';
import Slide6 from '../../images/slider/round-shape.png';
import Home from '../../images/slider/home-main-bg.png';
import MainBgVideo from '../../images/main.mp4';

gsap.registerPlugin(ScrollTrigger);

const Hero = () => {

    useEffect(() => {
        // // 비디오 자동 재생 강제
        // const video = document.querySelector('.hero-background-video');
        // if (video) {
        //     video.play().catch(err => {
        //         console.log('Video autoplay failed:', err);
        //     });
        // }

        const animatedElements = document.querySelectorAll(".new_img-animet");
        animatedElements.forEach((element) => {
            const image = element.querySelector("img");
            if (!image) return;

            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: element,
                    start: "top 50%",
                    toggleActions: "play none none reverse",
                },
            });

            tl.set(element, { autoAlpha: 1 });
            tl.from(element, { xPercent: -100, duration: 1.5, ease: "power2.out" });
            tl.from(image, { xPercent: 100, scale: 1.3, delay: -1.5, ease: "power2.out" });
        });

        return () => ScrollTrigger.getAll().forEach(trigger => trigger.kill());
    }, []);

    return (
        <section className="hero-section" style={{
            // backgroundImage: `url(${Home})`,
            // backgroundSize: 'cover',
            // backgroundPosition: 'center',
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        }}>
            <video
                className="hero-background-video"
                autoPlay
                loop
                muted
                playsInline
                preload="auto"
                src={MainBgVideo}
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    zIndex: 0
                }}
            />
            <div>
                <h2 className="scroll-text-animation" data-animation="fade_from_bottom" style={{
                    fontSize: window.innerWidth >= 768 ? '54px' : '28px', fontWeight:"700", lineHeight: window.innerWidth >= 768 ? "60px" : "30px"
                }}>폐수 자원 재이용</h2>
                <h2 className="normal scroll-text-animation" style={{
                    fontSize: window.innerWidth >= 768 ? '54px' : '28px', fontWeight:"700",
                    textAlign: window.innerWidth >= 768 ? "left" : "center"
                }}>
                    도시광산 산업을 {window.innerWidth < 768 && <br />} 선도하는 기업
                </h2>
                <div className="scroll-text-animation" data-animation="fade_from_right" style={{
                    textAlign: 'center'
                }}>
                    <p style={{
                        fontSize: window.innerWidth >= 768 ? '22px' : '16px', color:"#FFF", fontWeight:"400"
                    }}>
                        MR Metallo <br />
                        always thinks of human, environment { window.innerWidth >= 768 ? " " : <br /> }  and nature!
                    </p>
                </div>
            </div>
            {/* <div className="bg-shape">
                <img src={Slide5} alt="background shape" />
            </div>
            <div className="round-shape">
                <img src={Slide6} alt="round shape" />
            </div> */}
        </section>
    );
};

export default Hero;
